// src/contexts/ImageContext.js
import { createContext, useContext, useState } from 'react';

const ImageContext = createContext();

export const ImageProvider = ({ children }) => {
  const [processedImages, setProcessedImages] = useState([]);

  const addProcessedImage = (image) => {
    setProcessedImages(prev => [...prev, image]);
  };

  return (
    <ImageContext.Provider value={{ processedImages, addProcessedImage }}>
      {children}
    </ImageContext.Provider>
  );
};

export const useImageContext = () => {
  const context = useContext(ImageContext);
  if (!context) {
    throw new Error('useImageContext must be used within an ImageProvider');
  }
  return context;
};